export const appIconStyle = {
  marginLeft: '15px',
  height: '80px',
  width: '',
  marginTop: '-20px'
}
